import React from 'react'
import { useSelector } from 'react-redux'

import { Heading, PageLoader, PortalPage } from 'component-library-next'

import SafariSafe from '@app/common/Components/SafariSafe'
import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { NavBar } from '@app/NavBar'
import { useMyLawyerInformationQuery } from '@app/queries/MyLawyerInformation/MyLawyerInformation.queries'

function StatsContent() {
  const { data } = useMyLawyerInformationQuery()
  const isLawyerDashboardEnabled = useSelector(isFeatureEnabled(Features.LAWYER_DASHBOARD))

  if (data == null) {
    return <PageLoader loading />
  }
  const src = `https://re69ay540gkbz08.eu.qlikcloud.com/single/?appid=${data.myLawyerInformation.qlikAppId}&sheet=${data.myLawyerInformation.qlikSheetId}&opt=noselections,noInteraction`

  void login()

  return (
    <>
      <Heading size={Heading.sizes.medium}>
        <span>Statistik</span>
      </Heading>

      {!!isLawyerDashboardEnabled ? (
        <iframe src={src} style={{ border: 'none', width: '100%', height: '1000px' }} />
      ) : (
        <div>Diese Funktion ist nicht aktiviert.</div>
      )}
    </>
  )
}

function login() {
  const webIntegrationId = '8rKW6mLamVfvRTtu08eRlxIT91S0vaS_'
  function isLoggedIn() {
    return fetch('https://re69ay540gkbz08.eu.qlikcloud.com/api/v1/users/me', {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'qlik-web-integration-id': webIntegrationId
      }
    }).then((response) => {
      return response.status === 200
    })
  }

  return isLoggedIn().then((loggedIn) => {
    if (!loggedIn) {
      // check login
      window.location.href =
        'https://re69ay540gkbz08.eu.qlikcloud.com/login?qlik-web-integration-id=' +
        webIntegrationId +
        '&returnto=' +
        location.href
      throw new Error('not logged in')
    }
  })
}

export const StatsPage = () => (
  <NavBar title='Statistik'>
    <PortalPage hideFooter>
      <SafariSafe>
        <StatsContent />
      </SafariSafe>
    </PortalPage>
  </NavBar>
)
